import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import api from '../../services/api';
import CustomTable from '../common/Table';
import { getPickupRowStyle } from '../../services/helpers';

const ScheduledPickups = ({
  data,
  mode,
  onCancel,
  serverTimezone,
  states,
  handleUpdate,
}) => {
  const addressId = data.id;
  const [scheduledPickups, setScheduledPickups] = useState([]);
  const headers = [
    {
      header: 'Company', key: 'company.name', format: true,
    },
    { header: 'Pickup Id', key: 'id' },
    { header: 'Customer', key: 'customer', format: true },
    {
      header: 'Account', key: 'account', format: true,
    },
    { header: 'Cutoff', key: 'actual_cutoff_time' },
    {
      header: 'Origin Company Name', key: 'origin_company_name', format: true,
    },
    {
      header: 'Origin Attention To', key: 'origin_attention_to', format: true,
    },
    {
      header: 'Origin Street Address1', key: 'origin_street_address1', format: true,
    },
    {
      header: 'Origin Street Address2', key: 'origin_street_address2', format: true,
    },
    {
      header: 'Origin City', key: 'origin_city', format: true,
    },
    {
      header: 'Origin State', key: 'origin_state', format: true,
    },
    {
      header: 'Origin Zip', key: 'origin_zip', format: true,
    },
    {
      header: 'Origin Country', key: 'origin_country', format: true,
    },
    {
      header: 'Origin Phone', key: 'origin_phone', format: true,
    },
    { header: 'Owner', key: 'owner' },
  ];
  const [selectedRows, setSelectedRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    console.log(data);
    console.log(mode);
    api.pickupsDashboard.getScheduledPickupsByAddress(addressId, mode)
      .then((res) => {
        setScheduledPickups(res.scheduled_pickups);
        setSelectedRows(res.scheduled_pickups);
      })
      .catch(err => console.log(err))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="modal-body">
        <div style={{
          width: '100%',
          minHeight: '500px',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '12px',
          flexDirection: 'column',
        }}
        >
          <i className="fa fa-spinner fa-spin" style={{ fontSize: '5em' }} />
          <span style={{ fontSize: '1.5em' }}>Loading Scheduled Pickup List</span>
        </div>
      </div>
    );
  }

  return (
    <>
      <div className="modal-body">
        <CustomTable
          rows={scheduledPickups}
          formatters={{
            schedule_days: value => (value ? value.map(item => item.slice(0, 3)).join(', ') : '-'),
            package_cluster: ({ package_cluster }) => (package_cluster ? `${package_cluster.airport_code}@${package_cluster.id}` : '-'),
            customer: ({
              customer,
            }) => <div className="text-center" style={{ minWidth: '70px' }}>{`${customer?.first_name || ''} ${customer?.last_name || ''}`}</div>,
            account: ({ account }) => (account?.name || ''),
            is_on_call: value => <div className="text-center">{`${value ? '+' : '-'}`}</div>,
            airport: ({ package_cluster }) => (package_cluster && package_cluster.airport ? `${package_cluster.airport.name}` : '-'),
            origin_record_info: value => <span>{value ? value.record_id : '-'}</span>,
            'company.name': value => value.origin_record_json?.company?.name || value.company?.name,
            origin_company_name: value => value.origin_record_json?.company_name || value.origin_company_name,
            origin_attention_to: value => value.origin_record_json?.attention_to || value.origin_attention_to,
            origin_street_address1: value => value.origin_record_json?.street_address1 || value.origin_street_address1,
            origin_street_address2: value => value.origin_record_json?.street_address2 || value.origin_street_address2,
            origin_city: value => value.origin_record_json?.city || value.origin_city,
            origin_state: value => (value.origin_record_json ? states.find(state => state.id === parseInt(value.origin_record_json.state_id, 10))?.alpha2 : value.origin_state),
            origin_zip: value => value.origin_record_json?.zip || value.origin_zip,
            origin_country: value => value.origin_record_json?.country || value.origin_country,
            origin_phone: value => value.origin_record_json?.phone || value.origin_phone,
          }}
          rowsProps={headers}
          selectedRows={selectedRows}
          setSelectedRows={setSelectedRows}
          rowStyle={row => getPickupRowStyle(row, serverTimezone)}
          suffix="scheduled_pickup"
          styleTableContainer={{}}
        />
      </div>
      <div className="modal-bottom-btn text-right">
        <button
          disabled={saving}
          className="btn bg-olive"
          onClick={() => handleUpdate({ ...data, scheduled_pickup_ids: selectedRows.map(row => row.id) }, setSaving)}
        >
          Continue
        </button>
        <button
          className="btn btn-primary"
          style={{ marginLeft: '5px' }}
          onClick={onCancel}
        >
          Cancel
        </button>
      </div>
    </>
  );
};

ScheduledPickups.propTypes = {
  data: PropTypes.instanceOf(Object).isRequired,
  handleUpdate: PropTypes.func.isRequired,
  mode: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
  serverTimezone: PropTypes.string,
  states: PropTypes.instanceOf(Array).isRequired,
};

ScheduledPickups.defaultProps = {
  serverTimezone: 'America/Chicago',
};

export default ScheduledPickups;
